import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { PERMISSION_GROUP_QUERY_KEY } from "../permission-groups/usePermissionGroupQuery";
import { PERMISSION_GROUPS_QUERY_KEY } from "../permission-groups/usePermissionGroupsQuery";

export const useInvalidatePermissionGroups = () => {
  const queryClient = useQueryClient();
  return useCallback(
    async (id?: string) => {
      await queryClient.invalidateQueries({
        queryKey: [PERMISSION_GROUPS_QUERY_KEY]
      });
      await queryClient.invalidateQueries({
        predicate: (q) =>
          q.queryKey[0] === PERMISSION_GROUP_QUERY_KEY &&
          (id === undefined || q.queryKey[2] === id)
      });
    },
    [queryClient]
  );
};
